import { render } from "./ModalAddNewUser.vue?vue&type=template&id=600a6ac8&scoped=true"
import script from "./ModalAddNewUser.vue?vue&type=script&lang=js"
export * from "./ModalAddNewUser.vue?vue&type=script&lang=js"

import "./ModalAddNewUser.vue?vue&type=style&index=0&id=600a6ac8&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600a6ac8"]])

export default __exports__